export default {
  CURRENCYSYMBOL: '￥',
  MAXNINEDIGITNUM: 999999999,
  ATTACHEMENT_MAX_SIZE: 1024 * 1024 * 50, // 附件上传max size
  PICTURE_MAX_SIZE: 1024 * 1024 * 10, // 图片上传max size
  ATTACHEMENT_MAX_COUNT: 10, // 附件最大上传数量
  CUSTOMER_ATTACHEMENT_MAX_COUNT: 50, // 某些客户指定附件最大上传数量
  IMAGE_MAX_COUNT: 9, // 图片最大上传数量
  MAXSKUNUM: 600, // 最大物料单品数量
  MAXSKUNUMEXPAND: 1200, // 最大物料单品数量(新增物料使用)
  MTCOUNTDECIMAL: 4, // 物料小数位
  MAXDATETIMESTAMP: 4102358400000, // 最大时间戳：2100-01-01
  REFRESH_LOCK_GAP: 10000, // 轮训刷新锁列表的间隔时间 10秒一次
  PING_MESSAGE_GAP: 1000 * 15, // 初始的轮训全局消息通知的间隔时间 15秒一次
  CUSTOM_FIELD_PREFIX: 'customField-', // 自定义字段前缀
  SELECT_POPUP_TRIGGER: 'select-popup-trigger', // 下拉框触发器约定类名
};
